import { render } from "./OrderConfirmation.vue?vue&type=template&id=3593a5ca"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__